module.exports = __webpack_public_path__ + "img/PS.90969656.svg";